import React from 'react';
import LocationTemplate from './LocationTemplate';

const ConwayPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Conway"
      stateName="North Carolina"
      countyName="Northampton"
      zipCodes={["27820"]}
      latitude={36.4340}
      longitude={-77.2275}
      population={827}
      historicalFact="Incorporated in 1879, named after early settler Conway Whitehead."
      nearbyTowns={[
        "Jackson, NC",
        "Woodland, NC",
        "Rich Square, NC",
        "Severn, NC",
        "Murfreesboro, NC",
        "Seaboard, NC",
        "Ahoskie, NC",
        "Garysburg, NC"
      ]}
    />
  );
};

export default ConwayPage;